import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Mail, ArrowLeft, CheckCircle2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-navy p-6">
      <div className="w-full max-w-md bg-white rounded-lg border border-navy/10 p-8 shadow-xl">
        {sent ? (
          <div data-testid="forgot-success">
            <div className="w-12 h-12 rounded-md bg-green-100 flex items-center justify-center mb-5">
              <CheckCircle2 className="w-6 h-6 text-green-700" />
            </div>
            <h1 className="font-display text-2xl font-bold text-navy">Controlla la tua email</h1>
            <p className="text-sm text-muted-foreground mt-2">
              Se l'indirizzo è associato a un account, riceverai un link per reimpostare la password. Il link è valido per 1 ora.
            </p>
            <Link to="/login" className="inline-flex items-center gap-2 mt-6 text-sm font-semibold text-navy hover:text-navy-hover transition-colors">
              <ArrowLeft className="w-4 h-4" /> Torna al login
            </Link>
          </div>
        ) : (
          <>
            <div className="w-12 h-12 rounded-md bg-gold/15 flex items-center justify-center mb-5">
              <Mail className="w-6 h-6 text-gold" />
            </div>
            <p className="text-xs tracking-[0.15em] uppercase font-bold text-gold">Recupero credenziali</p>
            <h1 className="font-display text-2xl font-bold text-navy mt-2">Password dimenticata?</h1>
            <p className="text-sm text-muted-foreground mt-2">
              Inserisci la tua email: ti invieremo un link per impostare una nuova password.
            </p>
            <form onSubmit={submit} className="mt-6 space-y-4">
              <div className="space-y-2">
                <Label htmlFor="email">Email</Label>
                <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                  placeholder="nome@example.com" className="h-11" data-testid="forgot-email-input" />
              </div>
              {error && <p className="text-sm text-destructive font-medium" data-testid="forgot-error">{error}</p>}
              <Button type="submit" disabled={loading} data-testid="forgot-submit"
                className="w-full h-11 bg-navy hover:bg-navy-hover text-white font-semibold">
                {loading ? "Invio…" : "Invia link di reset"}
              </Button>
              <Link to="/login" className="flex items-center justify-center gap-2 text-sm text-muted-foreground hover:text-navy transition-colors">
                <ArrowLeft className="w-4 h-4" /> Torna al login
              </Link>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
